import $ from "jquery";

function linkPrivacyPolicy(container: Document | HTMLElement) {
    // Make the text "Privacy Policy" on checkbox labels a link
    $(".ktc-checkbox label", container).each(function () {
        const $label = $(this);

        // grab link and text from #js-privacy-policy-link element
        const $privacyPolicyLink = $("#js-privacy-policy-link");
        const privacyPolicyLink = $privacyPolicyLink.attr("href");
        const privacyPolicyText = $privacyPolicyLink.text().trim();
        if (privacyPolicyLink && privacyPolicyText) {
            $label.html(
                $label
                    .html()
                    .replace(
                        privacyPolicyText,
                        `<a class="underline text-white" target="_blank" href="${privacyPolicyLink}">${privacyPolicyText}</a>`
                    )
            );
        }
    });
}

$(function () {
    $(document).on("blur", "[submit-on-blur]", function (event) {
        const $form = $(event.target).parents("form").trigger("submit");
        $("input, textarea", $form).attr("disabled", "disabled");
    });

    linkPrivacyPolicy(document);

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node instanceof HTMLFormElement) {
                    linkPrivacyPolicy(node);
                }
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
});
